module.exports = __webpack_public_path__ + "static/media/tomyPopUp.5cf53600.png";